<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  inject: ['setLoading'],
  components: {
    Vue3ChartJs,
  },
  data() {
    return {
      errors: {},  
      errors: {},
      title: "Reports",
      text: "Lead Detailed Report",
      text1: "Reports",
      isCollapsed: false,
      app_currency: '',
      filter: {
        user: '',
        from_date: '',
        to_date: '',
      },
      users: [],
      data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
    };
  },

  computed: {
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   },
  },

  async mounted() {
    this.getUsers();
    this.app_currency = await this.$appCurrency();

    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

    //LOAD DATA
    this.filterReport();
  },

  methods: {

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async filterReport(page = 1) {
      this.errors = {};  
      this.setLoading(true);
      try{
       const payload = {
        page,
        user_id: this.filter.user,
        from_date: this.filter.from_date,
        to_date: this.filter.to_date
       };
       const query_string = new URLSearchParams(payload).toString(); 
       const response = await axios.get(`/reports/lead/detailed?${query_string}`);
       this.data = response.data.data.data;
       this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
       };

      }catch(error){
       if(error.type == 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await axios.get('/users/all-users');
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

     changePage(url) {
      if (!url) return;
      const page = new URL(url).searchParams.get("page");
      this.filterReport(page);
     },

    clearFilter() {
     this.filter = {
      user: ''
     };
     this.filterReport();
      // Optionally reset date picker UI too
      // (e.g., manually set this.$refs.dateRangeInput.value)
    }
  }
};
</script>


<template>
 <layout-header></layout-header>
 <layout-sidebar></layout-sidebar>
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
 <breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<!-- <div class="me-2 mb-2">
<div class="dropdown">
<a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
 <i class="ti ti-file-export me-1"></i>Export </a>
<ul class="dropdown-menu dropdown-menu-end p-3">
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a>
 </li>
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
 </li>
</ul>
 </div>
</div> -->
<!-- <div class="mb-2">
<div class="input-icon w-120 position-relative">
 <span class="input-icon-addon"> 
  <i class="ti ti-calendar text-gray-9"></i>
 </span>
 <a-date-picker class="form-control yearpicker" picker="year" value="2025" placeholder="2025" />
</div>
</div> -->
<div class="ms-2 head-icons">
 
</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card border-0">
<div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
  <div class="d-flex align-items-center flex-wrap mb-1">
   
   <div class="me-3" v-if="filter.user !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
     <select class="form-select" v-model="filter.user">
      <option value="">User</option>
      <option :value="row.id" v-for="row in users" :key="row.id">{{row.name}}</option>
     </select>
     <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="filterReport"><i class="ti ti-search"></i></button>
    </div>
   
  </div>
</div>
</div>

 <div class="row">
  <div class="col-lg-12">
<div class="custom-datatable-filter table-responsive">

<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Client Name</th>
    <th>Client Company</th>
    <th>Email</th>
    <th>Status</th>
    <th>Total Quotation</th>
    <th>Quotation Amount</th>
    <th>Total Proforma</th>
    <th>Proforma Amount</th>
    <th>Assigned To</th>
 </tr>
 </thead>
 <tbody>
 <tr v-for="(row, index) in data" :key="row.id">
    <td>{{ serialNo + index + 1 }}.</td>
    <td><h6 class="fs-14 fw-medium"> <a :href="`/crm/leads-details/${row.lead_id}`" target="_blank">{{ row.name }}</a> </h6></td>
    <td>{{ row.company_name }}</td>
    <td>{{ row.email }}</td>
    <td>{{ row.status }}</td>
    <td>
     <a class="text-primary" v-if="row.total_quotations > 0" href="javascript:void(0);" data-bs-target="#report_quotation_modal" data-bs-toggle="modal" @click="$refs.reportModal.getLeadQuotations(row.lead_id, filter.from_date, filter.to_date);"> {{ row.total_quotations }} </a>
     <span v-else class="text-muted">{{ row.total_quotations }}</span>
    </td>
    <td><b>{{app_currency.code}}</b> {{ row.total_quotations_amount }}</td>
    <td>
     <a class="text-primary" v-if="row.total_proforma_invoices > 0" href="javascript:void(0);" data-bs-target="#report_proforma_modal" data-bs-toggle="modal" @click="$refs.reportModal.getLeadProforma(row.lead_id, filter.from_date, filter.to_date);"> {{ row.total_proforma_invoices }} </a>
     <span v-else class="text-muted">{{ row.total_proforma_invoices }}</span>
    </td>
    <td><b>{{app_currency.code}}</b> {{ row.total_proforma_invoices_amount }}</td>
    <td>{{ row.user_name }}</td>
 </tr>
</tbody>
</table>

 <div v-else class="p-3 text-center text-muted"> No records found.</div>

   <!-- Pagination -->
  <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
    <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>

</div>
  </div>  
 </div>


</div>

<app-footer></app-footer>

</div>

<lead-report-modal ref="reportModal"></lead-report-modal>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>